import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDAvatar from "components/MDAvatar";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { API_ORIGIN } from "services/api";

// Resolve an icon path returned by the API into a full URL.
const resolveIcon = (icon) => {
  if (!icon) return "";
  if (/^https?:\/\//i.test(icon)) return icon;
  return `${API_ORIGIN}/${String(icon).replace(/^\//, "")}`;
};

export default function categoryTableData({ categoryList = [], onEditClick }) {
  return {
    columns: [
      { Header: "ID", accessor: "id", width: "8%", align: "center" },
      { Header: "Category", accessor: "name", width: "32%", align: "left" },
      { Header: "Slug", accessor: "slug", width: "20%", align: "left" },
      { Header: "Auto Parts", accessor: "isAutoParts", align: "center" },
      { Header: "Duty Estimator", accessor: "isDutyEstimatorAvailable", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: categoryList.map((category) => ({
      id: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {category.id}
        </MDTypography>
      ),
      name: (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDAvatar size="lg" sx={{ background: "#f0f2f5" }}>
            <img
              src={resolveIcon(category?.icon)}
              alt={category?.name}
              style={{ width: "60%", height: "60%", objectFit: "contain" }}
            />
          </MDAvatar>
          <MDTypography variant="button" fontWeight="medium">
            {category?.name}
          </MDTypography>
        </MDBox>
      ),
      slug: (
        <MDTypography variant="caption" color="text">
          {category?.slug || "—"}
        </MDTypography>
      ),
      isAutoParts: (
        <MDBadge
          badgeContent={category?.isAutoParts ? "Yes" : "No"}
          color={category?.isAutoParts ? "success" : "secondary"}
          variant="gradient"
          size="sm"
        />
      ),
      isDutyEstimatorAvailable: (
        <MDBadge
          badgeContent={category?.isDutyEstimatorAvailable ? "Yes" : "No"}
          color={category?.isDutyEstimatorAvailable ? "success" : "secondary"}
          variant="gradient"
          size="sm"
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <IconButton size="small" onClick={() => onEditClick(category)}>
            <EditIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
